import { Component, OnInit } from "@angular/core";
import { CatDescuentosService } from "../../servicios/cat-descuentos.service";
import { CatConceptosService } from "../../servicios/cat-conceptos.service";
import { CatTipoUsosService } from "../../servicios/cat-tipo-usos.service";
import { CatTipoPeriodosService } from "../../servicios/cat-tipo-periodos.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { CatDescuentos } from '../../entidades/entidades';
import { CatConceptos } from "../../entidades/entidades";
import { Table } from "primeng/table";

@Component({
  selector: "app-cat-descuentos",
  templateUrl: "./cat-descuentos.component.html",
  styleUrls: ["./cat-descuentos.component.css"],
})
export class CatDescuentosComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  catConceptos: SelectItem[];
  catConceptosAfecta: SelectItem[];
  catTipoUsos: SelectItem[];
  catTipoPeriodos: SelectItem[];
  catDescuentos: CatDescuentos[];
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  clonedCatDescuentos: { [s: string]: CatDescuentos } = {};
  es: any;

  constructor(
    private catDescuentosService: CatDescuentosService,
    private catConceptosService: CatConceptosService,
    private catTipoUsosService: CatTipoUsosService,
    private catTipoPeriodosService: CatTipoPeriodosService
  ) { }

  // prettier-ignore
  ngOnInit(): void {
    this.getAllCatConceptos();
    this.getAllCatConceptosAfecta();
    this.getAllCatTipoUsos();
    this.getAllCatTipoPeriodos();
    this.getAllCatDescuentos();

    this.es = {
      firstDayOfWeek: 0,
      dayNames: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
      monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Deciembre",],
    };

    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
      { label: "Guardar", icon: "pi pi-save", command: (event) => { this.guardarGridCatDescuentos(); } },
      { label: "Refrescar", icon: "pi pi-refresh", command: (event) => { this.getAllCatDescuentos(); } },
    ];

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      { field: "operacion", header: "Editar", ordenar: false, styleHeader: "width: 60px;" },
      { field: "acciones", header: "Eliminar", ordenar: false, styleHeader: "width: 60px;", },
      { field: "idConcepto", header: "Concepto", ordenar: true, styleHeader: "width: 250px;", },
      { field: "idConceptoAfecta", header: "Afecta", ordenar: true, styleHeader: "width: 180px;", },
      { field: "idTipoUso", header: "Uso", ordenar: true, styleHeader: "width: 180px;", },
      { field: "factorDescuento", header: "Factor", ordenar: true, styleHeader: "width: 60px;", },
      { field: "idTipoPeriodo", header: "Periodo", ordenar: true, styleHeader: "width: 125px;", },
      { field: "anioIni", header: "Año Ini", ordenar: true, styleHeader: "width: 70px;", },
      { field: "periodoParcialidadIni", header: "Parcialidad Ini", ordenar: true, styleHeader: "width: 80px;", },
      { field: "anioFin", header: "Año Fin", ordenar: true, styleHeader: "width: 70px;", },
      { field: "periodoParcialidadFin", header: "Parcialidad Fin", ordenar: true, styleHeader: "width: 80px;", },
      { field: "vigenciaIni", header: "Vigencia Ini", ordenar: true, styleHeader: "width: 100px;", },
      { field: "vigenciaFin", header: "Vigencia Fin", ordenar: true, styleHeader: "width: 100px;", },
      { field: "esCumplido", header: "Cumplido", ordenar: true, styleHeader: "width: 70px;", },

    ];
  }
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore
  add() {
    let catDescuentosNew = new CatDescuentos();
    catDescuentosNew.cambio = true;
    catDescuentosNew.id = 0;
    this.catDescuentos.unshift(catDescuentosNew);
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    let catDescuentosEdit = event.data;
    this.clonedCatDescuentos[catDescuentosEdit.id] = { ...catDescuentosEdit};
    catDescuentosEdit.cambio = true;
    catDescuentosEdit.baja = false;
  }

  // prettier-ignore
  onEditCancel(event) {
    let catDescuentosEdit = event.data;
    let index = this.catDescuentos.findIndex(
      (obj) => obj.id === catDescuentosEdit.id
    );
    this.catDescuentos[index] = { ...this.clonedCatDescuentos[catDescuentosEdit.id] };
  }

  // prettier-ignore
  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
  }

  // prettier-ignore
  async onEditComplete(event) {
    try {
      let catDescuentosEdit = event.data;

      //Valida si hay cambios
      if (
        catDescuentosEdit.id === this.clonedCatDescuentos[catDescuentosEdit.id].id &&
        catDescuentosEdit.idConcepto === this.clonedCatDescuentos[catDescuentosEdit.id].idConcepto &&
        catDescuentosEdit.idConceptoAfecta === this.clonedCatDescuentos[catDescuentosEdit.id].idConceptoAfecta &&
        catDescuentosEdit.idTipoUso === this.clonedCatDescuentos[catDescuentosEdit.id].idTipoUso &&
        catDescuentosEdit.factorDescuento === this.clonedCatDescuentos[catDescuentosEdit.id].factorDescuento &&
        catDescuentosEdit.idTipoPeriodo === this.clonedCatDescuentos[catDescuentosEdit.id].idTipoPeriodo &&
        catDescuentosEdit.anioIni === this.clonedCatDescuentos[catDescuentosEdit.id].anioIni &&
        catDescuentosEdit.periodoParcialidadIni === this.clonedCatDescuentos[catDescuentosEdit.id].periodoParcialidadIni &&
        catDescuentosEdit.anioFin === this.clonedCatDescuentos[catDescuentosEdit.id].anioFin &&
        catDescuentosEdit.periodoParcialidadFin === this.clonedCatDescuentos[catDescuentosEdit.id].periodoParcialidadFin &&
        catDescuentosEdit.vigenciaIni === this.clonedCatDescuentos[catDescuentosEdit.id].vigenciaIni &&
        catDescuentosEdit.vigenciaFin === this.clonedCatDescuentos[catDescuentosEdit.id].vigenciaFin &&
        catDescuentosEdit.esCumplido === this.clonedCatDescuentos[catDescuentosEdit.id].esCumplido
      ) {
        let index = this.catDescuentos.findIndex((obj) => obj.id === catDescuentosEdit.id);
        this.catDescuentos[index] = { ...this.clonedCatDescuentos[catDescuentosEdit.id] };
        return;
      }

      //Validaciones
      //throw new Error("No paso las validaciones.");

      catDescuentosEdit.cambio = true;
      catDescuentosEdit.baja = false;
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  // prettier-ignore
  async guardarGridCatDescuentos() {
    try {
      for (let catDescuentosFor of this.catDescuentos) {
        if (catDescuentosFor.factorDescuento > 100) {
          this.muestraMensaje.error("El descuento máximo aplicable es de 100%", "top", "center");
          return;
        }
        if (catDescuentosFor.factorDescuento <= -1) {
          this.muestraMensaje.error("El descuento mínimo aplicable es de 0%", "top", "center");
          return;
        }
        if (catDescuentosFor.baja) {
          await this.deleteCatDescuentos(catDescuentosFor);
        } else if (catDescuentosFor.cambio) {
          catDescuentosFor.cambio = false;
          this.clonedCatDescuentos[catDescuentosFor.id] = { ...catDescuentosFor, };
          if (catDescuentosFor.id === 0) {
            const datoRetorno = await this.addCatDescuentos(catDescuentosFor);
            catDescuentosFor.id = datoRetorno.id;
          } else {
            await this.updateCatDescuentos(catDescuentosFor);
          }
        }
      }

      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarCatDescuentos");
    }
  }

  // prettier-ignore
  async addCatDescuentos(catDescuentos) {
    try {
      const datoretorno = await this.catDescuentosService
        .add(catDescuentos)
        .toPromise();
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addCatDescuentos");
    }
  }

  // prettier-ignore
  async getAllCatDescuentos() {
    try {
      const datoRetorno = await this.catDescuentosService.getAll().toPromise();
      for (var i = 0, len = datoRetorno.length; i < len; ++i) {
        datoRetorno[i].vigenciaIni = new Date(datoRetorno[i].vigenciaIni);
        datoRetorno[i].vigenciaFin = new Date(datoRetorno[i].vigenciaFin);
      }
      this.catDescuentos = datoRetorno;
      for (var i = 0, len = this.catDescuentos.length; i < len; ++i)
        this.clonedCatDescuentos[this.catDescuentos[i].id] = { ...this.catDescuentos[i], };
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCatDescuentos");
    }
  }

  // prettier-ignore
  async updateCatDescuentos(catDescuentos: CatDescuentos) {
    try {
      const datoRetorno = await this.catDescuentosService
        .update(catDescuentos)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateCatDescuentos");
    }
  }

  // prettier-ignore
  async deleteCatDescuentos(catDescuentos: CatDescuentos) {
    try {
      const datoRetorno = await this.catDescuentosService
        .delete(catDescuentos.id)
        .toPromise();
      this.getAllCatDescuentos();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteCatDescuentos");
    }
  }

  // prettier-ignore
  async getAllCatConceptos() {
    try {

      let catConceptosDescuentos: CatConceptos[];

      const datoRetorno = await this.catConceptosService.getAll().toPromise();
      console.log('datoRetorno', datoRetorno);
      // catConceptosDescuentos = datoRetorno.filter(a => a.idGrupoConcepto == 2) && a.id in (131, 132, 133, 134, 135, 136, 137);
      catConceptosDescuentos = datoRetorno.filter(this.filtraConceptos);

      this.catConceptos = catConceptosDescuentos.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatConceptos");
    }
  }

  filtraConceptos(catConcepto) {
    return (
      catConcepto.idGrupoConcepto == 2 &&
      [131, 132, 133, 134, 135, 136, 137].indexOf(catConcepto.id) == -1
    );
  }

  // prettier-ignore
  async getAllCatConceptosAfecta() {
    try {

      let catConceptosDescuentos: CatConceptos[];

      const datoRetorno = await this.catConceptosService.getAll().toPromise();

      catConceptosDescuentos = datoRetorno.filter(a => a.idGrupoConcepto == 3);

      this.catConceptosAfecta = catConceptosDescuentos.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatConceptosAfecta");
    }
  }

  // prettier-ignore
  async getAllCatTipoUsos() {
    try {
      const datoRetorno = await this.catTipoUsosService.getAll().toPromise();
      this.catTipoUsos = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catTipoUsos.unshift({ label: "Todos", value: null });

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatTipoUsos");
    }
  }

  // prettier-ignore
  async getAllCatTipoPeriodos() {
    try {
      const datoRetorno = await this.catTipoPeriodosService.getAll().toPromise();

      this.catTipoPeriodos = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catTipoPeriodos.unshift({ label: "Todos", value: null });

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatTipoPeriodos");
    }
  }
}
